import i18n from "../../i18n";
import React, { useEffect } from "react";
import { MapContainer, TileLayer, Marker, Popup, useMap, useMapEvents } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

// Fix default marker icons for webpack (Leaflet references broken URLs otherwise)
const DefaultIcon = L.icon({
    iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
    iconRetinaUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
    shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41],
});
L.Marker.prototype.options.icon = DefaultIcon;

function ClickHandler({ onPick }) {
    useMapEvents({
        click(e) { onPick(e.latlng.lat, e.latlng.lng); },
    });
    return null;
}

function Recenter({ center }) {
    const map = useMap();
    useEffect(() => {
        if (center && center[0] && center[1]) map.setView(center, map.getZoom());
    }, [center, map]);
    return null;
}

/**
 * PlotMap
 * - When `pickable=true` and `onPick` given → single-marker picker (click to drop pin)
 * - Otherwise → shows all plots that have lat/lng as markers
 */
export default function PlotMap({
    plots = [], center, zoom = 13, pickable = false, onPick, height = 260,
}) {
    // Default centre: Philippines (Manila area) if nothing else
    const defaultCenter = center && center[0] ? center : [14.5995, 120.9842];
    const markers = pickable
        ? (center && center[0] ? [{ id: "pin", lat: center[0], lng: center[1], name: "Selected" }] : [])
        : plots.filter(p => p.lat && p.lng);

    return (
        <div style={{ height }} className="rounded-lg overflow-hidden border">
            <MapContainer center={defaultCenter} zoom={zoom} style={{ height: "100%", width: "100%" }} scrollWheelZoom>
                <TileLayer
                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
                {pickable && onPick && <ClickHandler onPick={onPick} />}
                {center && center[0] && <Recenter center={center} />}
                {markers.map((p) => (
                    <Marker key={p.id} position={[p.lat, p.lng]}>
                        <Popup>
                            <div className="text-sm">
                                <div className="font-semibold">{p.name || "Plot"}</div>
                                {p.crop && <div className="text-xs">{p.crop}</div>}
                                {p.area_ha && <div className="text-xs">{p.area_ha} {i18n.t("final.f9fc27b9374a")}</div>}
                            </div>
                        </Popup>
                    </Marker>
                ))}
            </MapContainer>
        </div>
    );
}
